import ViewActionTypes from './view.types';
import UserActionTypes from '../user/user.types';

const INITIAL_STATE = {
  currentView: "GettingStarted",
  viewData: {}
}

const viewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SIGN_OUT_SUCCESS:
      return INITIAL_STATE;
    case ViewActionTypes.SET_CURRENT_VIEW:
      return {
        ...state,
        currentView: action.payload.currentView,
        viewData: action.payload.viewData
      };
    default:
      return state;
  }
}

export default viewReducer;